import React, { Component } from "react";
import {
  Button,
  Container,
  Row,
  Form,
  Col,
  Card,
  Tooltip,
  Table,
  OverlayTrigger,
} from "react-bootstrap";
import { toast } from "react-toastify";
import configData from "../config.json";

import LoadingOverlay from "./LoadingOverlay";
export default class IntegrationLibrarynew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      requestId: sessionStorage.getItem("requestId"),
      integrationlibrary_Id: sessionStorage.getItem("integrationlibrary_Id"),
      errors: {},
      filteredData: null,
      Integrationtype: [],
      AuthenticationMethods: [],
      ExternalencryptionsSelect: [],
      amFields: [],
      amAFields: [],
      sendingHeader: [],
      AuthenticationMethodKeys: {},
      AuthenticationMethodAKeys: {},
      AuthenticationMethodValues: {},
      AuthenticationMethodAValues: {},
      currentPage: 1,
      itemsPerPage: 10,
      partnerName: "",
      apiName: "",
      apiDescription: "",
      ipUrl: "",
      authenticationMethod: "",
      type: "",
      inputMethod: "",
      eeId: 0,
      headerData: {
        key: "",
        sampleValue: "",
      },
      authenticationValue: {},
      isSubmitted: false,
      jsonData: "",
      SampleJSONrequest: [],
      isSuccessretrieve: false,
      showRetrieveButton: false,
    };
  }
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg); // 'warn' is used instead of 'warning'
        break;
      default:
        toast.info(msg);
    }
  };
  c;
  IntegrationlibraryeditHandler = (e) => {
    e.preventDefault();
    // const updateFormData = {...editFormData};
    // updateFormData['Integrationlibrary_Id'] = e.target.parentElement.getAttribute("id");
    // setEditFormData(updateFormData);
    // setEdit(true);
  };
  addSendhrRow = (e) => {
    e.preventDefault();
    if (this.keyvalidatehr()) {
      this.setState((prevState) => ({
        sendingHeader: [...prevState.sendingHeader, prevState.headerData],
        headerData: {
          ...prevState.headerData,
          key: "",
          sampleValue: "",
        },
      }));
    }
  };

  keyvalidatehr() {
    const { currentStep, headerData } = this.state;
    let formIsValid = true;
    if (!headerData["key"]) {
      formIsValid = false;
      toast.info("*Enter Header Key.");
    } else if (!headerData["sampleValue"]) {
      formIsValid = false;
      toast.info("*Enter Header Sample value.");
    } else {
      // If all fields are filled, proceed to the next step
      this.setState({ currentStep: currentStep + 1 });
    }
    return formIsValid;
  }

  handleRemoveSpecificRowHeader = (idx) => {
    const tempRows = this.state.sendingHeader; // to avoid  direct state mutation
    tempRows.splice(idx, 1);
    this.setState({ sendingHeader: tempRows });
  };
  handleEditInputChangeHeader(index, field, value) {
    const updatedHeader = [...this.state.sendingHeader];
    updatedHeader[index][field] = value;
    // this.getColumns(value, "rcolumns");
    this.setState({ sendingHeader: updatedHeader });
  }
  inputSHrChange = (e) => {
    e.preventDefault();
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;
    const inputData = this.state.headerData;

    inputData[fieldName] = fieldValue;
    this.setState({ headerData: inputData });
    console.log(this.state.headerData);
  };

  handleinputMethodChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ inputMethod: fieldValue });
  };
  IntegrationlibraryfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Integrationlibrary/list", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      });
  };

  IntegrationlibrarysubmitHandler = (e) => {
    e.preventDefault();
    var amValues = this.state.AuthenticationMethodValues;
    this.setState({ isSubmitted: true });
    //   setButtons(contacts);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("partnerName", this.state.partnerName);
    formData.append("apiName", this.state.apiName);
    formData.append("apiDescription", this.state.apiDescription);
    formData.append("ipUrl", this.state.ipUrl);
    formData.append("authenticationMethod", this.state.authenticationMethod);
    formData.append("amValues", JSON.stringify(amValues));
    formData.append("type", this.state.type);
    formData.append("inputMethod", this.state.inputMethod);
    formData.append("inputHeaders", JSON.stringify(this.state.sendingHeader));
    formData.append("eeId", this.state.eeId);
    formData.append("dummyOne", "");
    formData.append("dummyTwo", "");
    formData.append("dummyThree", "");
    formData.append("dummyFour", "");
    formData.append("dummyFive", "");
    formData.append("dummySix", "");
    formData.append("dummySeven", "");
    formData.append("dummyEight", "");
    formData.append("dummyNine", "");
    formData.append("dummyTen", "");
    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Integrationlibrary/add", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          setTimeout(() => {
            window.location.href = "/requestjson";
          }, 1500);

          sessionStorage.setItem(
            "integrationlibrary_Id",
            data.integrationlibrary_Id
          );
          this.IntegrationlibraryfetchHandler();

          this.setState({
            integrationlibrary_Id: data.integrationlibrary_Id,
            partnerName: "",
            apiName: "",
            apiDescription: "",
            ipUrl: "",
            authenticationMethod: "",

            type: "",
          });
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  IntegrationlibraryupdateHandler = (e) => {
    e.preventDefault();
    var amValues = this.state.AuthenticationMethodValues;
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integrationlibrary_Id", this.state.integrationlibrary_Id);
    formData.append("partnerName", this.state.partnerName);
    formData.append("apiName", this.state.apiName);
    formData.append("apiDescription", this.state.apiDescription);
    formData.append("ipUrl", this.state.ipUrl);
    formData.append("authenticationMethod", this.state.authenticationMethod);
    formData.append("amValues", JSON.stringify(amValues));
    formData.append("type", this.state.type);
    formData.append("inputMethod", this.state.inputMethod);
    formData.append("inputHeaders", JSON.stringify(this.state.sendingHeader));
    formData.append("eeId", this.state.eeId);
    formData.append("dummyOne", "");
    formData.append("dummyTwo", "");
    formData.append("dummyThree", "");
    formData.append("dummyFour", "");
    formData.append("dummyFive", "");
    formData.append("dummySix", "");
    formData.append("dummySeven", "");
    formData.append("dummyEight", "");
    formData.append("dummyNine", "");
    formData.append("dummyTen", "");

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Integrationlibrary/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          setTimeout(() => {
            window.location.href = "/requestjson";
          }, 1500);


        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  IntegrationtypemastersfetchHandler = () => {
    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Integrationtypemasters/list", {
      // Enter your IP address here

      method: "POST",

      //headers :{ 'Content-Type' : 'application/json'},

      mode: "cors",

      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())

      .then((data) => {
        if (data.status === "success") {
          this.setState({ Integrationtype: data.list });
        }
      });
  };
  ExternalencryptionsfetchHandler = () => {
    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Externalencryptions/list", {
      // Enter your IP address here

      method: "POST",

      //headers :{ 'Content-Type' : 'application/json'},

      mode: "cors",

      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())

      .then((data) => {
        if (data.status === "success") {
          this.setState({ ExternalencryptionsSelect: data.list });
        }
      });
  };
  // Externalencryptions
  AuthenticationmethodfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Authenticationmethod/list", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        var AuthenticationMethodKeys = {};
        var AuthenticationMethodAKeys = {};
        if (data.status === "success") {
          this.setState({ AuthenticationMethods: data.list });
          var i = 0;
          for (i = 0; i < data.list.length; i++) {
            var amFields = [];
            var amAFields = [];
            if (data.list[i].amFields !== "") {
              amFields = JSON.parse(JSON.parse(data.list[i].amFields));
              // console.log(amFields, typeof amFields);
            }
            if (data.list[i].amAFields !== "") {
              amAFields = JSON.parse(JSON.parse(data.list[i].amAFields));
              // console.log(amAFields, typeof amAFields);
            }
            // [{ "fieldName": "Token", "fieldType": "text", "defaultValues": "" }];
            // console.log(typeof amFields, "--", data.list[i].methodName);
            AuthenticationMethodKeys[data.list[i].methodName] = amFields;
            AuthenticationMethodAKeys[data.list[i].methodName] = amAFields;
            // console.log(AuthenticationMethodKeys);
            // console.log(AuthenticationMethodAKeys);
          }
          this.setState({
            AuthenticationMethodKeys: AuthenticationMethodKeys,
            AuthenticationMethodAKeys: AuthenticationMethodAKeys,
          });
        }
      });
  };
  clearForm = () => {
    this.setState({
      integrationlibrary_Id: "",
      partnerName: "",
      apiName: "",
      apiDescription: "",
      ipUrl: "",
      authenticationMethod: "",
      type: "",
      inputMethod: "",
      sendingHeader: [],
      amFields: [],
      amAFields: [],
      AuthenticationMethodValues: {},
      AuthenticationMethodAValues: {},
    });
  };

  componentDidMount() {
    this.IntegrationlibraryfetchHandler();
    this.IntegrationtypemastersfetchHandler();
    this.AuthenticationmethodfetchHandler();
    this.IntegrationlibraryfetchHandlerSaveJson();
    this.ExternalencryptionsfetchHandler();
    const actionType = sessionStorage.getItem("actionType"); // Check action type
    if (actionType === "edit") {
      this.RetrivefetchHandler(); // Fetch only if action is edit
    } else {
      this.clearForm(); // For 'new', clear the form
    }
    const isNew = sessionStorage.getItem("isNewEntry");
    if (isNew === "true") {
      this.setState({ isNewEntry: true });
      this.clearForm(); // Show empty form for new entry
    } else {
      this.setState({ isNewEntry: false });
      this.RetrivefetchHandler(); // Fetch data for back scenario
    }
  }
  handlepartnerNameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ partnerName: fieldValue });
  };
  handleapiNameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ apiName: fieldValue });
  };
  handleapiDescriptionChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ apiDescription: fieldValue });
  };
  handleipUrlChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ ipUrl: fieldValue });
  };
  handleauthenticationMethodChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;

    // Handle "Select Type" option
    if (fieldValue === "Select Type" || !fieldValue) {
      this.setState({
        authenticationMethod: "",
        amFields: [],
        amAFields: [],
        AuthenticationMethodValues: {},
        AuthenticationMethodAValues: {},
      });
      return;
    }

    const amFields = this.state.AuthenticationMethodKeys[fieldValue] || [];
    const amAFields = this.state.AuthenticationMethodAKeys[fieldValue] || [];

    // Clear previous values and initialize new empty values for the selected method
    var AuthenticationMethodValues = {};
    var AuthenticationMethodAValues = {};

    if (amFields && amFields.length > 0) {
      amFields.forEach(function (key) {
        AuthenticationMethodValues[key["fieldName"]] = "";
      });
    }

    if (amAFields && amAFields.length > 0) {
      amAFields.forEach(function (key) {
        AuthenticationMethodAValues[key["fieldName"]] = "";
      });
    }

    this.setState({
      authenticationMethod: fieldValue,
      amFields: amFields,
      amAFields: amAFields,
      AuthenticationMethodValues: AuthenticationMethodValues,
      AuthenticationMethodAValues: AuthenticationMethodAValues,
    });
  };

  handletypeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ type: fieldValue });
  };
  handleExternalencryptionsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ eeId: fieldValue });
  };
  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };
  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };
  handleinputAChange(fieldName, fieldType, fieldValue) {
    const AuthenticationMethodValues = this.state.AuthenticationMethodValues;
    fieldType = fieldName;
    AuthenticationMethodValues[fieldName] = fieldValue;
    this.setState({ AuthenticationMethodValues: AuthenticationMethodValues });
  }
  handleinputAAChange(fieldName, fieldType, fieldValue) {
    const AuthenticationMethodAValues = this.state.AuthenticationMethodAValues;
    fieldType = fieldName;
    AuthenticationMethodAValues[fieldName] = fieldValue;
    this.setState({ AuthenticationMethodAValues: AuthenticationMethodAValues });
  }
  IntegrationlibraryfetchHandlerSaveJson = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Integrationlibrary/saveJson", {
      method: "POST",
      mode: "cors",
      body: {},
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      });
  };
  RetrivefetchHandler = (e) => {
    // e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integrationlibrary_Id", this.state.integrationlibrary_Id);
    fetch(configData.api_url + "C_Integrationlibrary/retrive", {
      // Enter your IP address here
      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          const {
            integrationlibrary_Id,
            partnerName,
            apiName,
            apiDescription,
            authenticationMethod,
            ipUrl,
            amValues,
            type,
            inputMethod,
            inputHeaders,
          } = data.detail;

          // Parse amValues if it's a string
          let parsedAmValues = {};
          if (amValues) {
            try {
              parsedAmValues = typeof amValues === 'string' ? JSON.parse(amValues) : amValues;
            } catch (e) {
              console.error("Error parsing amValues:", e);
              parsedAmValues = {};
            }
          }

          // Get authentication method fields from the stored keys
          const amFields = this.state.AuthenticationMethodKeys[authenticationMethod] || [];
          const amAFields = this.state.AuthenticationMethodAKeys[authenticationMethod] || [];

          // Initialize AuthenticationMethodValues with saved values
          let AuthenticationMethodValues = {};
          let AuthenticationMethodAValues = {};

          // Populate values from parsed amValues
          if (amFields.length > 0) {
            amFields.forEach((field) => {
              AuthenticationMethodValues[field.fieldName] = parsedAmValues[field.fieldName] || "";
            });
          }

          if (amAFields.length > 0) {
            amAFields.forEach((field) => {
              AuthenticationMethodAValues[field.fieldName] = parsedAmValues[field.fieldName] || "";
            });
          }

          this.setState({
            data: data.list,
            integrationlibrary_Id,
            partnerName,
            apiName,
            apiDescription,
            ipUrl,
            authenticationMethod,
            amValues: parsedAmValues,
            type,
            inputMethod,
            sendingHeader: inputHeaders ? JSON.parse(inputHeaders) : [],
            amFields: amFields,
            amAFields: amAFields,
            AuthenticationMethodValues: AuthenticationMethodValues,
            AuthenticationMethodAValues: AuthenticationMethodAValues,
          });
        }
      });
  };
  handleFormSubmit = (e) => {
    e.preventDefault();
    const integrationlibrary_Id =
      this.state.integrationlibrary_Id ||
      sessionStorage.getItem("integrationlibrary_Id");
    console.log("Using integrationlibrary_Id:", integrationlibrary_Id);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", this.state.integrationlibrary_Id);

    fetch(configData.api_url + "C_Integrationlibrary/saveJson", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({ isSuccess: true, requestId: data.requestId });
          this.IntegrationlibraryfetchHandlerSaveJson();
          // sessionStorage.setItem("requestId", data.requestId);
          setTimeout(() => {
            window.location.href = "./requestjson";
            this.setState({ showRetrieveButton: true });
          }, 10000);
        }

        //
      });
    console.log(formData);
  };

  onSubmitTest = (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    fetch(configData.api_url + "apis/testapi", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          sessionStorage.setItem("requestId", data.requestId);
        }
      });
  };

  handleFormRetrie = (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integrationlibrary_Id", this.state.requestId);
    fetch(configData.api_url + "C_Integrationlibrary/retriveJson", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({
            isSuccessretrieve: true,
            SampleJSONrequest: [],
          });
        }
      })
      .catch((error) => console.error("Error:", error));
  };
  handleJsonChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ jsonData: fieldValue });
  };
  generatePalceholder = (value1, value2) => {
    let returnValue = value1 + value2;
    // console.log(returnValue);
    return returnValue;
  };

  renderTooltip = (text) => <Tooltip id="button-tooltip">{text}</Tooltip>;
  render() {
    const {
      isSubmitted,
      // isSuccess, isSuccessretrieve, jsonData
    } = this.state;
    return (
      <div>
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <Container style={{ overflowY: "auto", height: "auto" }}>
          <Row className="mb-3">
            <Col xs={4} sm={4} lg={4}>
              <OverlayTrigger
                placement="top"
                overlay={this.renderTooltip("Integration Library")}
              >
                <Card className="nav-card active-step">
                  <span className="bi bi-boxes nav-icon"></span>
                  <p className="nav-label">Integration Library</p>
                </Card>
              </OverlayTrigger>
            </Col>

            <Col xs={4} sm={4} lg={4}>
              <OverlayTrigger
                placement="top"
                overlay={this.renderTooltip("Request JSON")}
              >
                <Card
                  className="nav-card "
                  onClick={() => this.setState({ step: 2 })}
                >
                  <span className="bi bi-journal-album nav-icon"></span>
                  <p className="nav-label">Request JSON</p>
                </Card>
              </OverlayTrigger>
            </Col>

            <Col xs={4} sm={4} lg={4}>
              <OverlayTrigger
                placement="top"
                overlay={this.renderTooltip("Response JSON Mapping")}
              >
                <Card
                  className="nav-card"
                  onClick={() => this.setState({ step: 3 })}
                >
                  <span className="bi bi-table nav-icon"></span>
                  <p className="nav-label">Response JSON Mapping</p>
                </Card>
              </OverlayTrigger>
            </Col>
          </Row>

          <Row className="divstyle">
            <Row>
              <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>
                Integration Library
              </h3>
              <Card>
                <Form>
                  <Row>
                    <Col lg="4" md="4">
                      <Form.Label style={{ paddingTop: "8px" }}>
                        Partner Name
                      </Form.Label>

                      <Form.Control
                        type="text"
                        disabled={isSubmitted}
                        onChange={this.handlepartnerNameChange}
                        className="form-control"
                        name="partnerName"
                        value={this.state.partnerName}
                        required="required"
                        placeholder="Enter Partner Name"
                      />
                    </Col>
                    <Col lg="4" md="4">
                      <Form.Label style={{ paddingTop: "8px" }}>
                        API Name
                      </Form.Label>

                      <Form.Control
                        disabled={isSubmitted}
                        type="text"
                        onChange={this.handleapiNameChange}
                        className="form-control"
                        name="apiName"
                        value={this.state.apiName}
                        required="required"
                        placeholder="Enter API Name"
                      />
                    </Col>

                    <Col lg="4" md="4">
                      <Form.Label style={{ paddingTop: "8px" }}>
                        API Description
                      </Form.Label>

                      <Form.Control
                        disabled={isSubmitted}
                        type="text"
                        onChange={this.handleapiDescriptionChange}
                        className="form-control"
                        name="apiDescription"
                        value={this.state.apiDescription}
                        required="required"
                        placeholder="Enter API Description "
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="4" md="4">
                      <Form.Label style={{ paddingTop: "8px" }}>
                        IP/URL
                      </Form.Label>

                      <Form.Control
                        disabled={isSubmitted}
                        type="text"
                        onChange={this.handleipUrlChange}
                        className="form-control"
                        name="ipUrl"
                        value={this.state.ipUrl}
                        required="required"
                        placeholder="Enter IP/URL"
                      />
                    </Col>
                    <Col lg="4" md="4">
                      <Form.Label style={{ paddingTop: "8px" }}>
                        Integration Type
                      </Form.Label>

                      <Form.Control
                        disabled={isSubmitted}
                        as="select"
                        onChange={this.handletypeChange}
                        className="form-select"
                        name="type"
                        value={this.state.type}
                        required="required"
                        placeholder="Enter Type"
                      >
                        <option defaultValue>Select Integration Type</option>
                        {this.state.Integrationtype.map((api, index, idx) => (
                          <option key={index} value={api.typeName}>
                            {api.typeName}
                          </option>
                        ))}
                      </Form.Control>
                    </Col>

                    <Col lg="4" md="4">
                      <Form.Label style={{ paddingTop: "8px" }}>
                        Authentication Type
                      </Form.Label>

                      <Form.Control
                        disabled={isSubmitted}
                        as="select"
                        onChange={this.handleauthenticationMethodChange}
                        className="form-select"
                        name="authenticationMethod"
                        value={this.state.authenticationMethod}
                        required="required"
                      >
                        <option defaultValue>Select Type</option>
                        {this.state.AuthenticationMethods.map(
                          (api, index, idx) => (
                            <option key={index} value={api.methodName}>
                              {api.methodName}
                            </option>
                          )
                        )}
                      </Form.Control>
                    </Col>
                    <Col lg="4" md="4">
                      <Form.Label style={{ paddingTop: "8px" }}>
                        External Encryptions
                      </Form.Label>

                      <Form.Control
                        disabled={isSubmitted}
                        as="select"
                        onChange={this.handleExternalencryptionsChange}
                        className="form-select"
                        name="Externalencryptions"
                        value={this.state.Externalencryptions}
                        required="required"
                      >
                        <option defaultValue>Select Type</option>
                        {this.state.ExternalencryptionsSelect.map(
                          (api, index, idx) => (
                            <option
                              key={index}
                              value={api.externalencryptions_Id}
                            >
                              {api.eeName}
                            </option>
                          )
                        )}
                      </Form.Control>
                    </Col>
                    <Col lg="4" md="4">
                      <Form.Label style={{ paddingTop: "8px" }}>
                        Select Method{" "}
                      </Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        name="inputMethod"
                        value={this.state.inputMethod}
                        onChange={this.handleinputMethodChange}
                      >
                        <option>Select method</option>
                        <option value="GET">GET</option>
                        <option value="POST">POST</option>
                        <option value="PUT">PUT</option>
                        <option value="PATCH">PATCH</option>
                        <option value="DELETE">DELETE</option>
                        <option value="LINK">LINK</option>
                        <option value="LINK">UNLINK</option>
                        <option value="HEAD">HEAD</option>
                        <option value="PURGE">PURGE</option>
                        <option value="LOCK">LOCK</option>
                        <option value="UNLOCK">UNLOCK</option>
                      </Form.Select>
                    </Col>
                  </Row>

                  <br />
                </Form>
              </Card>

              <br />
              {this.state.amFields.length > 0 ? (
                <Card>
                  <Row>
                    <Col>
                      <div className="row">
                        {this.state.amFields.map((api, index, idx) => (
                          <div className="col-md-4 col-lg-6" key={idx}>
                            <Form.Label style={{ paddingTop: "8px" }}>
                              {api.labelName}
                            </Form.Label>
                            {api.fieldType === "checkbox" ? (
                              <Form.Check
                                type={api.fieldType}
                                className="form-check"
                                name={api.fieldName}
                                checked={this.state.AuthenticationMethodValues[api.fieldName] === "true" || this.state.AuthenticationMethodValues[api.fieldName] === true}
                                onChange={(e) =>
                                  this.handleinputAChange(
                                    api.fieldName,
                                    api.fieldType,
                                    e.target.checked
                                  )
                                }
                              />
                            ) : api.fieldType !== "select" ? (
                              <Form.Control
                                type={api.fieldType}
                                className="form-control"
                                name={api.fieldName}
                                value={this.state.AuthenticationMethodValues[api.fieldName] || ""}
                                onChange={(e) =>
                                  this.handleinputAChange(
                                    api.fieldName,
                                    api.fieldType,
                                    e.target.value
                                  )
                                }
                                placeholder={this.generatePalceholder(
                                  "Enter ",
                                  api.labelName
                                )}
                              />
                            ) : (
                              <Form.Control
                                as={api.fieldType}
                                className="form-select"
                                placeholder={this.generatePalceholder(
                                  "Select ",
                                  api.fieldName
                                )}
                                value={
                                  this.state.AuthenticationMethodAValues[
                                  api.fieldName
                                  ]
                                } // Assuming 'token' is the state variable for the text box
                                onChange={(e) =>
                                  this.handleinputAChange(
                                    api.fieldName,
                                    api.fieldType,
                                    e.target.value
                                  )
                                } // Update the token value in state
                              >
                                {api.defaultValues.split(",").map((line) => (
                                  <option value={line}>{line}</option>
                                ))}
                              </Form.Control>
                            )}
                            <br />
                          </div>
                        ))}
                      </div>
                    </Col>
                  </Row>
                </Card>
              ) : (
                ""
              )}
              {this.state.amAFields.length > 0 ? (
                <Card>
                  <Row>
                    <Col>
                      <div className="row">
                        {this.state.amAFields.map((api, index, idx) => (
                          <div className="col-md-4 col-lg-6">
                            <Form.Label style={{ paddingTop: "8px" }}>
                              {api.fieldName} -- {api.fieldName}
                            </Form.Label>
                            {api.fieldType === "checkbox" ? (
                              <Form.Check
                                checked={
                                  this.state.AuthenticationMethodAValues[
                                  api.fieldName
                                  ] || false
                                }
                                type="checkbox"
                                className="form-check"
                                name={api.fieldName}
                                onChange={(e) =>
                                  this.handleinputAAChange(
                                    api.fieldName,
                                    api.fieldType,
                                    e.target.checked
                                  )
                                }
                                placeholder={this.generatePalceholder(
                                  "Enter ",
                                  api.fieldName
                                )}
                              />
                            ) : api.fieldType !== "select" ? (
                              <Form.Control
                                type={api.fieldType}
                                className="form-control"
                                name={api.fieldName}
                                value={this.state.AuthenticationMethodAValues[api.fieldName] || ""}
                                onChange={(e) =>
                                  this.handleinputAAChange(
                                    api.fieldName,
                                    api.fieldType,
                                    e.target.value
                                  )
                                }
                                placeholder={this.generatePalceholder(
                                  "Enter ",
                                  api.fieldName
                                )}
                              />
                            ) : (
                              <Form.Control
                                as={api.fieldType}
                                className="form-select"
                                placeholder={this.generatePalceholder(
                                  "Select ",
                                  api.fieldName
                                )}
                                value={this.state.AuthenticationMethodAValues[api.fieldName] || ""}
                                onChange={(e) =>
                                  this.handleinputAAChange(
                                    api.fieldName,
                                    api.fieldType,
                                    e.target.value
                                  )
                                }
                              >
                                {api.defaultValues.split(",").map((line) => (
                                  <option value={line}>{line}</option>
                                ))}
                              </Form.Control>
                            )}
                            <br />
                          </div>
                        ))}
                      </div>
                    </Col>
                  </Row>
                </Card>
              ) : (
                ""
              )}
              <Card>
                <Card.Header>Headers</Card.Header>
                <Card.Body>
                  <div className="table-responsive">
                    <Table
                      className="table table-bordered table-hover"
                      id="tab_logic"
                      responsive
                    >
                      <thead>
                        <tr>
                          <th className="text-center" style={{ width: '60px', minWidth: '60px' }}>S.NO</th>
                          <th className="text-center" style={{ minWidth: '150px' }}>KEY</th>
                          <th className="text-center" style={{ minWidth: '150px' }}>Sample</th>
                          <th className="text-center" style={{ width: '100px', minWidth: '100px' }}>Actions</th>
                        </tr>
                      </thead>
                    <tbody>
                      {this.state.sendingHeader.length > 0 ? (
                        this.state.sendingHeader.map((api, index, idx) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                              {this.state.editingIndex === index ? (
                                <Form.Control
                                  type="Text"
                                  value={api.key}
                                  onChange={(e) =>
                                    this.handleEditInputChangeHeader(
                                      index,
                                      "key",
                                      e.target.value
                                    )
                                  }
                                />
                              ) : (
                                api.key
                              )}
                            </td>

                            <td>
                              {this.state.editingIndex === index ? (
                                <Form.Control
                                  type="Text"
                                  name="sampleValue"
                                  placeholder="Sample"
                                  value={api.sampleValue}
                                  onChange={(e) =>
                                    this.handleEditInputChangeHeader(
                                      index,
                                      "sampleValue",
                                      e.target.value
                                    )
                                  }
                                />
                              ) : (
                                api.sampleValue
                              )}
                            </td>
                            <td>
                              {this.state.editingIndex !== index && ( // Condition to render Add button above the row being edited
                                <button
                                  variant="danger"
                                  className="bi bi-trash-fill btn btn-danger"
                                  onClick={() =>
                                    this.handleRemoveSpecificRowHeader(index)
                                  }
                                ></button>
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6"> No Records</td>
                        </tr>
                      )}
                      <tr>
                        <td>---</td>
                        <td>
                          <Form.Control
                            type="Text"
                            name="key"
                            placeholder="Key Value"
                            value={this.state.headerData.key}
                            onChange={this.inputSHrChange}
                          />
                          <div className="errorMsg" style={{ color: "red" }}>
                            {this.state.errors.key}
                          </div>
                        </td>

                        <td>
                          <Form.Control
                            type="Text"
                            name="sampleValue"
                            placeholder="Sample Value"
                            value={this.state.headerData.sampleValue}
                            onChange={this.inputSHrChange}
                          />
                        </td>
                        <td>
                          <Button
                            type="button"
                            variant="success"
                            // className="bi bi-plus"
                            onClick={this.addSendhrRow}
                          >
                            Add
                          </Button>
                        </td>
                      </tr>
                    </tbody>
                    </Table>
                  </div>
                </Card.Body>
              </Card>
            </Row>
          </Row>
          <Row>
            <Col
              className="d-flex justify-content-end"
              style={{ marginRight: "50px" }}
            >
              {/* <Button
                className="button"
                variant="success"
                onClick={this.IntegrationlibrarysubmitHandler}
                style={{
                  marginTop: "20px",
                }}
              >
                Save
              </Button> */}
              {this.state.integrationlibrary_Id ? (
                <Button
                  className="button"
                  variant="primary"
                  onClick={this.IntegrationlibraryupdateHandler}
                  style={{ marginTop: "20px" }}
                >
                  Update
                </Button>
              ) : (
                <Button
                  className="button"
                  variant="success"
                  onClick={this.IntegrationlibrarysubmitHandler}
                  style={{ marginTop: "20px" }}
                >
                  Save
                </Button>
              )}
            </Col>
            <p>Integration Id :{this.state.integrationlibrary_Id}</p>
          </Row>
        </Container>
      </div>
    );
  }
}
